module.exports = __webpack_public_path__ + "static/media/categories.99e336db.svg";